package feature.businessConfig.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Currency(
    @SerialName("symbol") var symbol: String = "",
    @SerialName("name") var name: String? = null,
    @SerialName("symbol_native") var symbol_native: String? = null,
    @SerialName("decimal_digits") var decimal_digits: Float? = null,
    @SerialName("rounding") var rounding: Float? = null,
    @SerialName("code") var code: String? = null,
    @SerialName("name_plural") var name_plural: String? = null,
)